import styled from '@emotion/styled';
import { mq } from 'responsive';

/* Emotion forwards to a DOM element only the props it recognises as HTML attributes, so it drops `test-id`.
   The elements below carry a `test-id`: they forward every prop except their own styling props. */
const forwardAllExcept = (...styleProps: string[]): { shouldForwardProp: (prop: PropertyKey) => boolean } => ({
  shouldForwardProp: (prop: PropertyKey): boolean => typeof prop === 'string' && !styleProps.includes(prop),
});

export const Container = styled.div`
  background-color: ${({ theme }): string => theme.SECONDARY};
  width: 100%;
  height: 70px;

  display: flex;
  align-items: center;
  padding: 0px 10px 0px 18px;

  ${mq.mobile} {
    position: relative;
    padding: 0px 8px;
  }
`;

export const SideBarButton = styled('button', forwardAllExcept('isOpen'))<{ isOpen: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;

  ${({ isOpen }): string => (isOpen ? '' : 'transform: rotate(180deg)')};

  cursor: pointer;
`;

export const Menu = styled.ul`
  margin-left: 40px;
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const MenuItem = styled.li<{ selected: boolean }>`
  cursor: pointer;

  font-weight: 400;
  font-size: 18px;
  color: ${({ theme, selected }): string => (selected ? theme.PRIMARY : theme.WHITE)};
`;

export const Logo = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 0 10px;
  margin-left: 18px;

  ${mq.mobile} {
    margin-left: 8px;
    padding: 0 6px;
  }
`;

export const User = styled.div`
  margin-left: auto;
`;

export const Burger = styled('button', forwardAllExcept())`
  margin-left: auto;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const MobileBackdrop = styled.div`
  position: fixed;
  top: 70px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.3);
`;

export const MobilePanel = styled('ul', forwardAllExcept())`
  position: absolute;
  top: 70px;
  right: 0;
  left: 0;
  z-index: 1002;
  background-color: ${({ theme }): string => theme.SECONDARY};
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
`;

export const MobileMenuItem = styled('li', forwardAllExcept('selected'))<{ selected?: boolean }>`
  min-height: 48px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  cursor: pointer;
  font-size: 18px;
  color: ${({ theme, selected }): string => (selected ? theme.PRIMARY : theme.WHITE)};
  border-top: 1px solid rgba(255, 255, 255, 0.15);
`;

export const MobileUser = styled('li', forwardAllExcept())`
  min-height: 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px 20px;
  cursor: pointer;
  color: ${({ theme }): string => theme.WHITE};
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 14px;

  & > span {
    font-size: 12px;
    opacity: 0.8;
  }
`;
